import type { CharmSuggestionsItem } from 'owa-calendar-charm-suggestions-data';
import { action } from 'satcheljs';
import type { CharmInfo } from 'owa-calendar-charms-store';

/**
 * Action called to set the charm manually
 */
export let onManualCharmChanged = action(
    'onManualCharmChanged',
    (charm: CharmInfo, formId: string) => ({
        charm: charm,
        formId: formId,
    })
);

/**
 * Action called to set the charm from suggestions for quick compose
 */
export let onCharmSuggestionChanged = action(
    'onCharmSuggestionChanged',
    (charmSuggestionItem: CharmSuggestionsItem, formId: string) => ({
        charmSuggestionItem: charmSuggestionItem,
        formId: formId,
    })
);

/**
 * Action called to set the charm automatically from the subject text
 */
export let onAutomaticCharmChanged = action(
    'onAutomaticCharmChanged',
    (subject: string, formId: string) => ({
        subject: subject,
        formId: formId,
    })
);
